export const IS_LOADING = 'IS_LOADING';
export const BROKER_CONCENTRATION_RESULT_BY = 'BROKER_CONCENTRATION_RESULT_BY';
export const BROKER_CONCENTRATION_SET_SECTOR = 'BROKER_CONCENTRATION_SET_SECTOR';

// async function
export const BROKER_CONCENTRATION_TABLE_DATA = 'BROKER_CONCENTRATION_TABLE_DATA';
export const BROKER_CONCENTRATION_RELOADED_TIME = 'BROKER_CONCENTRATION_RELOADED_TIME';



// WEBPACK FOOTER //
// ./src/dalalstreet/src/redux/BrokerConcentration/ActionTypes.ts